import classnames from "classnames";
import PropTypes from "prop-types";
import { useComponentInView } from "../../hooks/useComponentInView";
import { dataTableCopy } from "../../hooks/useMetadata/dataTableCopy";
import useOutputReportStore from "../../store/OutputReport.store";
import Tooltip from "../Tooltip";

import "./disclosures.scss";

const Disclosures = ({
  heading,
  bodyContent,
  className,
  footnote,
  isReportPage,
}) => {
  const { ref } = useComponentInView();

  const metadata = useOutputReportStore().metadata;
  const sectionMetadata = metadata?.Disclosures || {};
  const { sectionKeyKebab, legalCopy: metadataLegalCopy } = sectionMetadata;

  /*
    used useMetadata dataTableCopy as fallback for legal copy since it not yet
    included in the metadata api response
  */
  const legalCopy = metadataLegalCopy
    ? metadataLegalCopy
    : dataTableCopy.legalCopy;

  return (
    <section
      ref={ref}
      id={`section-${sectionKeyKebab}`}
      className={classnames("disclosures", className)}
    >
      <h2 className="disclosures__heading">{heading}</h2>
      <div className="disclosures__body-container">
        {bodyContent?.map((item, index) => {
          return (
            <div className="disclosures__body-item" key={index}>
              <div className="disclosures__body-heading-wrapper">
                <h3 className="disclosures__body-item-heading">
                  {item.heading}
                </h3>
                {item.tooltipText && (
                  <Tooltip {...item.tooltipText} direction="right" />
                )}
              </div>
              <div className="disclosures__body-item-content">
                {item.content}
              </div>
            </div>
          );
        })}
      </div>
      {legalCopy && (
        <div className="disclosures__footnote">
          <p className="disclosures__legal-copy">{legalCopy}</p>
        </div>
      )}
    </section>
  );
};

Disclosures.propTypes = {
  heading: PropTypes.string.isRequired,
  bodyContent: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      tooltipText: PropTypes.shape({
        header: PropTypes.string,
        content: PropTypes.string,
        showTooltipOnLoad: PropTypes.bool,
      }),
      content: PropTypes.node.isRequired,
    })
  ),
  className: PropTypes.string,
  footnote: PropTypes.node,
  isReportPage: PropTypes.bool,
};

Disclosures.defaultProps = {
  heading: "Disclosures",
  isReportPage: true,
};

export default Disclosures;
